import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'

import Button from '../Button/Button'
import Icon from '../Icon/Icon'
import './ShortLink.css'

export const ShortLink = ({ url, t }) => {
  const copyURL = () => {
    navigator.clipboard.writeText(url)
  }

  return (
    <div className="sc-pr-link">
      <span className="sc-pr-link__text">{url}</span>
      <Button
        className="sc-pr-link__button"
        icon={<Icon type="copy" />}
        onClick={copyURL}
        aria-label={t('pathway.copy-link')}
        title={t('pathway.copy-link')}
      />
    </div>
  )
}

ShortLink.propTypes = {
  url: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default translate('translations')(ShortLink)
